const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20interview%20scene%20with%20two%20silhouetted%20figures%20facing%20each%20other%2C%20warm%20amber%20spotlight%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20cinematic%20composition%2C%20interrogation%20room%20vibe&width=800&height=450&seq=media-01-2026&orientation=landscape',
    title: '独家对话：前娱乐圈经纪人揭秘行业内幕',
    duration: '45:32',
    views: '256万',
    tag: '独家访谈',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20investigative%20scene%20with%20documents%20spread%20on%20a%20wooden%20table%2C%20dramatic%20desk%20lamp%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20red%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20detective%20vibe&width=800&height=450&seq=media-02-2026&orientation=landscape',
    title: '深度调查：某上市公司财务造假全链条复盘',
    duration: '32:18',
    views: '189万',
    tag: '深度调查',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20newsroom%20with%20multiple%20monitors%20displaying%20data%2C%20dramatic%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20golden%20amber%20accents%2C%20film%20noir%20style%2C%20deep%20shadows%2C%20investigative%20journalism%20vibe&width=800&height=450&seq=media-03-2026&orientation=landscape',
    title: '年度盘点：2026上半年十大重磅爆料回顾',
    duration: '58:06',
    views: '312万',
    tag: '年度特辑',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            独家视频
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            暗网吃瓜视频频道，深度访谈、事件复盘、年度盘点一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-200/80 border border-background-300/30 rounded-xl overflow-hidden hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-xs px-2 py-0.5 rounded bg-background-950/60 text-foreground-400 whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 text-[10px] px-2 py-0.5 rounded bg-accent-500/80 text-background-50">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}